module.exports = __webpack_public_path__ + "img/aer-pampa-2.ae28e435.jpg";